import { AxiosResponse } from 'axios';
import configuration from 'config';
import MensajeRecordatorios, { MensajeRecordatoriosAPII } from 'types/models/mensajes-recordatorios';
import apiService from './ApiService';

export class MensajesRecordatoriosService {
  private http = apiService;

  private apiUrl = configuration.apiUrl;

  public async getAll(): Promise<MensajeRecordatorios[]> {
    const url = `${this.apiUrl}/onboarding/mensajes-recordatorios/`;
    const response: AxiosResponse<MensajeRecordatoriosAPII[]> = await this.http.get(url);
    return new MensajeRecordatorios().deserializeArray(response.data);
  }

  public async getById(id: number): Promise<MensajeRecordatorios> {
    const url = `${this.apiUrl}/onboarding/mensajes-recordatorios/${id}/`;
    const response: AxiosResponse<MensajeRecordatoriosAPII> = await this.http.get(url);
    return new MensajeRecordatorios().deserialize(response.data);
  }

  public async updateById(id: number, data: Partial<MensajeRecordatoriosAPII>): Promise<MensajeRecordatorios> {
    const url = `${this.apiUrl}/onboarding/mensajes-recordatorios/${id}/`;
    const response: AxiosResponse<MensajeRecordatoriosAPII> = await this.http.put(url, data);
    return new MensajeRecordatorios().deserialize(response.data);
  }
}

const mensajesRecordatoriosService = new MensajesRecordatoriosService();
export default mensajesRecordatoriosService;
